export { Layout1 } from './Layout1';
export { Layout2 } from '../layouts/Layout2';
export { Layout3 } from '../layouts/Layout3';
export { Layout4 } from '../layouts/Layout4';
export { Layout5 } from '../layouts/Layout5';
export { Layout6 } from '../layouts/Layout6';
export { Layout7 } from '../layouts/Layout7';
export { Layout8 } from './Layout8';